import React from 'react'

import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/Menu/MenuItem'

export const PORTAL_FILTER_STORAGE_KEY = 'cdpcrm_portal_filter'
export const PORTAL_ALL = 'TUTTI'
export const PORTAL_CASE_DEL_PARCO = 'CASE_DEL_PARCO'
export const PORTAL_PARCO_ESTATE = 'PARCO_ESTATE'

export const CASE_DEL_PARCO_INTEREST = 'Case del Parco'
export const PARCO_ESTATE_INTEREST = 'Parco Estate'

const CASE_DEL_PARCO_COLOR = '#ff9800'
const PARCO_ESTATE_COLOR = '#17365d'

const EMPTY_PORTALS = {
  caseDelParco: false,
  parcoEstate: false,
}

const normalizePortalValue = (value) => {
  if (typeof value !== 'string') return ''

  return value
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '')
}

const isValidPortalFilter = (value) => {
  return value === PORTAL_ALL || value === PORTAL_CASE_DEL_PARCO || value === PORTAL_PARCO_ESTATE
}

export const getStoredPortalFilter = () => {
  try {
    const value = window.localStorage.getItem(PORTAL_FILTER_STORAGE_KEY)
    return isValidPortalFilter(value) ? value : PORTAL_ALL
  } catch (error) {
    return PORTAL_ALL
  }
}

export const storePortalFilter = (value) => {
  const portalFilter = isValidPortalFilter(value) ? value : PORTAL_ALL

  try {
    window.localStorage.setItem(PORTAL_FILTER_STORAGE_KEY, portalFilter)
  } catch (error) {
    // Il filtro continua a funzionare per la pagina corrente anche senza storage.
  }

  return portalFilter
}

export const getPortalInterestFromFilter = (value) => {
  if (value === PORTAL_CASE_DEL_PARCO) return CASE_DEL_PARCO_INTEREST
  if (value === PORTAL_PARCO_ESTATE) return PARCO_ESTATE_INTEREST
  return null
}

const getPortalsFromValues = (values) => {
  if (!Array.isArray(values)) return EMPTY_PORTALS

  return values.reduce(
    (portals, value) => {
      const normalizedValue = normalizePortalValue(value)

      if (normalizedValue === 'casedelparco') portals.caseDelParco = true
      if (normalizedValue === 'parcoestate') portals.parcoEstate = true

      return portals
    },
    { ...EMPTY_PORTALS }
  )
}

export const getPortalsFromInterests = (interessi) => {
  if (!Array.isArray(interessi)) return EMPTY_PORTALS

  return getPortalsFromValues(
    interessi.map((interesse) => {
      if (typeof interesse === 'string') return interesse
      return interesse && interesse.nome
    })
  )
}

export const getPortalsFromOffer = (offerta) => {
  const tipoOfferta = offerta && offerta.tipoOfferta && offerta.tipoOfferta.tipo
  const portalsFromType = getPortalsFromValues([tipoOfferta])

  if (portalsFromType.caseDelParco || portalsFromType.parcoEstate) return portalsFromType

  const nomeOfferta = offerta && offerta.nome
  const portaleNelNome = typeof nomeOfferta === 'string' && nomeOfferta.match(/\s*-\s*(case[\s_-]*del[\s_-]*parco|parco[\s_-]*estate)\s*$/i)

  return getPortalsFromValues([portaleNelNome && portaleNelNome[1]])
}

export class PortalFilter extends React.Component {
  handleChange = (event) => {
    const value = storePortalFilter(event.target.value)
    if (this.props.onChange) this.props.onChange(value)
  }

  render() {
    const { value, style } = this.props

    return (
      <div style={{ minWidth: 210, ...style }}>
        <TextField id="portal-filter" label="Portale" select fullWidth value={isValidPortalFilter(value) ? value : PORTAL_ALL} onChange={this.handleChange}>
          <MenuItem value={PORTAL_ALL}>Tutti i portali</MenuItem>
          <MenuItem value={PORTAL_CASE_DEL_PARCO}>Case del Parco</MenuItem>
          <MenuItem value={PORTAL_PARCO_ESTATE}>Parco Estate</MenuItem>
        </TextField>
      </div>
    )
  }
}

export class PortalIndicators extends React.Component {
  renderIndicator = (active, color, label) => {
    return (
      <span
        title={label}
        aria-label={label}
        style={{
          display: 'inline-block',
          width: 12,
          height: 12,
          marginRight: 4,
          border: `1px solid ${active ? color : '#bdbdbd'}`,
          backgroundColor: active ? color : 'transparent',
          boxSizing: 'border-box',
          verticalAlign: 'middle',
        }}
      />
    )
  }

  render() {
    const { portals = EMPTY_PORTALS, showInactive = true, style } = this.props
    const portalValues = portals || EMPTY_PORTALS
    const caseDelParco = !!portalValues.caseDelParco
    const parcoEstate = !!portalValues.parcoEstate

    if (!showInactive && !caseDelParco && !parcoEstate) return null

    return (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap', lineHeight: 1, ...style }}>
        {(showInactive || caseDelParco) && this.renderIndicator(caseDelParco, CASE_DEL_PARCO_COLOR, 'Case del Parco')}
        {(showInactive || parcoEstate) && this.renderIndicator(parcoEstate, PARCO_ESTATE_COLOR, 'Parco Estate')}
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Portal/Portal.jsx